export default __webpack_public_path__ + "static/dont-links-icon-or-shape-94ae6d14a47fc3e7f814c60a2f36b958.png";